import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2300ParamStatus: 'idle',
    startProcess2300ParamError: undefined as any,
    loadUserParamsProcess2300ParamStatus: 'idle',
    loadUserParamsProcess2300ParamError: undefined as any,

    process2300ParamList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2300Param = createAsyncThunk('process2300ParamSlice/startProcess2300Param', async ({ process2300Param }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2300Param/`,
        prepareData(process2300Param),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2300ParamStatus } = getState().process2300ParamSlice
        return startProcess2300ParamStatus !== 'pending'
    }
})

export const loadUserParamsProcess2300Param = createAsyncThunk('process2300ParamSlice/loadUserParamsProcess2300Param', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2300Param/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2300ParamStatus } = getState().process2300ParamSlice
        return loadUserParamsProcess2300ParamStatus !== 'pending'
    }
})

const Process2300ParamSlice = createSlice({
    name: 'process2300ParamSlice',
    initialState,
    reducers: {
        resetstartProcess2300Param: (state) => {
            state.job = undefined
            state.startProcess2300ParamError = undefined
        },
        resetstartProcess2300ParamError: (state) => {
            state.startProcess2300ParamError = undefined
        },
        resetloadUserParamsProcess2300Param: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2300ParamError = undefined
        },
        resetloadUserParamsProcess2300ParamError: (state) => {
            state.loadUserParamsProcess2300ParamError = undefined
        },
        removeFromProcess2300ParamListById: (state, action) => {
            state.process2300ParamList = state.process2300ParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2300ParamListByIds: (state, action) => {
            state.process2300ParamList = state.process2300ParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2300ParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2300ParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2300ParamList = []
            state.startProcess2300ParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2300Param.pending, (state) => {
            state.startProcess2300ParamStatus = 'pending'
            state.startProcess2300ParamError = undefined
        })
        builder.addCase(startProcess2300Param.fulfilled, (state, action) => {
            state.startProcess2300ParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2300Param.rejected, (state, action) => {
            state.startProcess2300ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2300ParamError = action.error.message
            } else {
                state.startProcess2300ParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2300Param.pending, (state) => {
            state.loadUserParamsProcess2300ParamStatus = 'pending'
            state.loadUserParamsProcess2300ParamError = undefined
        })
        builder.addCase(loadUserParamsProcess2300Param.fulfilled, (state, action) => {
            state.loadUserParamsProcess2300ParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2300Param.rejected, (state, action) => {
            state.loadUserParamsProcess2300ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2300ParamError = action.error.message
            } else {
                state.loadUserParamsProcess2300ParamError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2300Param,
    resetstartProcess2300ParamError,
    resetloadUserParamsProcess2300Param,
    resetloadUserParamsProcess2300ParamError,
    removeFromProcess2300ParamListById,
    removeFromProcess2300ParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2300ParamSlice.actions
export default Process2300ParamSlice.reducer
